import {
  BoardColumn,
  BoardColumnCreate,
  BoardColumnUpdate,
  ItemColumnValue,
  MovePreview,
  UserBoardColumnPreferences,
  UserBoardColumnPreferencesUpdate,
} from '../types';
import { apiGet, apiPost, apiPut, apiDelete } from '../../../shared/api/axiosInstance';

const API_BASE = '/api/v1/tasks';

export const columnApi = {
  // Board Columns
  list: async (boardId: string): Promise<{ data: BoardColumn[] }> => {
    return apiGet<{ data: BoardColumn[] }>(`${API_BASE}/boards/${boardId}/columns`);
  },

  get: async (columnId: string): Promise<{ data: BoardColumn }> => {
    return apiGet<{ data: BoardColumn }>(`${API_BASE}/columns/${columnId}`);
  },

  create: async (boardId: string, data: BoardColumnCreate): Promise<{ data: BoardColumn }> => {
    return apiPost<{ data: BoardColumn }>(`${API_BASE}/boards/${boardId}/columns`, data);
  },

  update: async (columnId: string, data: BoardColumnUpdate): Promise<{ data: BoardColumn }> => {
    return apiPut<{ data: BoardColumn }>(`${API_BASE}/columns/${columnId}`, data);
  },

  delete: async (columnId: string): Promise<void> => {
    await apiDelete(`${API_BASE}/columns/${columnId}`);
  },

  getItemCount: async (columnId: string): Promise<{ data: { count: number } }> => {
    return apiGet<{ data: { count: number } }>(`${API_BASE}/columns/${columnId}/task-count`);
  },

  reorder: async (columnId: string, position: number): Promise<{ data: BoardColumn }> => {
    return apiPut<{ data: BoardColumn }>(`${API_BASE}/columns/${columnId}/reorder`, { position });
  },

  // Item Column Values
  getItemValues: async (taskId: string): Promise<{ data: ItemColumnValue[] }> => {
    return apiGet<{ data: ItemColumnValue[] }>(`${API_BASE}/${taskId}/column-values`);
  },

  setItemValue: async (
    taskId: string,
    columnKey: string,
    value: unknown
  ): Promise<{ data: ItemColumnValue }> => {
    return apiPut<{ data: ItemColumnValue }>(`${API_BASE}/${taskId}/column-values/${columnKey}`, {
      value,
    });
  },

  // Move Preview
  getMovePreview: async (
    taskId: string,
    targetBoardId: string
  ): Promise<{ data: MovePreview }> => {
    return apiGet<{ data: MovePreview }>(
      `${API_BASE}/${taskId}/move-preview?target_board_id=${targetBoardId}`
    );
  },

  // Move to Board
  moveToBoard: async (
    taskId: string,
    targetBoardId: string,
    targetGroupId?: string
  ): Promise<{ data: unknown }> => {
    return apiPut<{ data: unknown }>(`${API_BASE}/${taskId}/move-to-board`, {
      target_board_id: targetBoardId,
      target_group_id: targetGroupId,
    });
  },

  // User Board Column Preferences
  getColumnPreferences: async (
    boardId: string
  ): Promise<{ data: UserBoardColumnPreferences }> => {
    return apiGet<{ data: UserBoardColumnPreferences }>(
      `${API_BASE}/boards/${boardId}/column-preferences`
    );
  },

  updateColumnPreferences: async (
    boardId: string,
    data: UserBoardColumnPreferencesUpdate
  ): Promise<{ data: UserBoardColumnPreferences }> => {
    return apiPut<{ data: UserBoardColumnPreferences }>(
      `${API_BASE}/boards/${boardId}/column-preferences`,
      data
    );
  },
};
